<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}">
        <navbar-toggle-button @click.native="toggleSidebar">
        </navbar-toggle-button>
      </div>
      <a class="navbar-brand" href="#">
        {{ routeName }}
      </a>
    </div>
    <button @click="toggleNavbar" class="navbar-toggler" type="button" data-toggle="collapse"
            data-target="#navigation"
            aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>

    <template slot="navbar-menu">

      <!-- <form>
        <div class="input-group no-border">
          <fg-input placeholder="Search..." addon-right-icon="now-ui-icons ui-1_zoom-bold">
          </fg-input>
        </div>
      </form> -->

      <ul class="navbar-nav">
        <drop-down tag="li"
                   position="right"
                   class="nav-item"
                   icon="now-ui-icons users_single-02">

          <a class="dropdown-item" @click="select()" v-if="selectable">Alterar empresa</a>
          <a class="dropdown-item" @click="logout()">Sair</a>
        </drop-down>
      </ul>

    </template>
  </navbar>
</template>
<script>
  import {RouteBreadCrumb, Navbar, NavbarToggleButton} from 'src/components';
  import {CollapseTransition} from 'vue2-transitions'

  export default {
    components: {
      RouteBreadCrumb,
      Navbar,
      NavbarToggleButton,
      CollapseTransition
    },
    computed: {
      routeName() {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false,
        selectable: false,
      }
    },
    methods: {
      logout() {
        this.$router.push('/login')
        localStorage.clear()
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      select() {
        this.removeRemainingConfigs() 
        this.$router.replace('/select')
      },
      removeRemainingConfigs(){
        var arr = []; // Array to hold the keys
        // Iterate over localStorage and insert the keys that meet the condition into arr
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).substring(0,7) == 'config_') {
                arr.push(localStorage.key(i));
            }
        }

        // Iterate over arr and remove the items by key
        for (var i = 0; i < arr.length; i++) {
            localStorage.removeItem(arr[i]);
        }
      }
    },
    mounted() {

        let stores = JSON.parse(localStorage.getItem('stores'));
        let stores_app = JSON.parse(localStorage.getItem('stores_app'));
        if((stores || stores_app) && stores.length+stores_app.length > 1) {
          this.selectable = true;
        }
    }
  }

</script>
<style>

</style>
